export class RequisitionResponseDto {
  id: string;
  created: string;
  redirect: string;
  status: string;
  institution_id: string;
  agreement: string;
  reference: string;
  user_language: string;
  link: string;
  accounts: string[];
  ssn: string;
  account_selection: boolean;
  redirect_immediate: boolean;
}